import React from 'react';
import imgMain from "../../../src/images/preliminary.png";
import './DevPage.scss';


export default class DevPage extends React.Component {
    render() {
        return (
            <div className="DevPage">
                <div className='container'>
                    <p className='main'>В разработке</p>
                    <p className='explain'>Наш сайт в настоящее время находится на техническом обслуживании. Мы надеемся скоро вернуться. Благодарим вас за внимание.</p>  
                </div>

                <div className='container'>
                    <img src={imgMain} className='imgMain' alt='imageDevelopment'/>
                </div>
                

            </div>
        )
    }
}